import { render, staticRenderFns } from "./AddReceiver.vue?vue&type=template&id=14a83042&scoped=true&"
import script from "./AddReceiver.vue?vue&type=script&lang=js&"
export * from "./AddReceiver.vue?vue&type=script&lang=js&"
import style0 from "./AddReceiver.vue?vue&type=style&index=0&id=14a83042&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a83042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
